// extracted by mini-css-extract-plugin
module.exports = {"text":"SGNews_text__kBFcY","header":"SGNews_header__o6FaY"};